/**
 * @voltxampere/ui — ATtiny84 variant (Sprint 43-5, placeholder)
 *
 * PLACEHOLDER. Full GPIO + ADC + PWM simulation arrives Sprint 46+.
 *
 * Reference: Microchip ATtiny84A-PU, DIP-14. AVR-8bit family.
 * Vcc 1.8-5.5 V, fmax 20 MHz, 8 KB Flash / 512 B SRAM / 512 B EEPROM,
 * 12 GPIO, 8-channel 10-bit ADC, 4 PWM, USI (SPI/I2C).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuAttiny84 = {
    id: "attiny84",
    nameTr: "ATtiny84 (DIP-14, placeholder)",
    nameEn: "ATtiny84 (DIP-14, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ATtiny84",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 80e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-attiny84.js.map